import { API } from "../constant"
import { generalApi } from "./interceptor"

export const postContact = async (payload) => {
    const response = await generalApi.post(
        API.CONTACT,
        {
            fullname: payload.fullname,
            email: payload.email,
            subject: payload.subject,
            phone: payload.phone,
            website: "EGP",
            message: payload.message,
            recaptchaToken: payload.recaptchaToken,
        }
    )
    return response
}

export const getLatestNews = async () => {
    const response = await generalApi.get(
        API.NEWS,
        {
            params: {
                populate: "*",
                "fields[0]": "title",
                "fields[1]": "slug",
                "fields[2]": "source",
                "fields[3]": "link",
                "fields[4]": "highlight",
                "fields[5]": "published_date",
                "fields[6]": "content",
                "fields[7]": "website",
                "sort[1]": "published_date:desc",
                "pagination[limit]": 3,
            },
        }
    )
    return response
}

export const getAllNews = async () => {
    const response = await generalApi.get(
        API.NEWS,
        {
            params: {
                populate: "*",
                "fields[0]": "title",
                "fields[1]": "slug",
                "fields[2]": "source",
                "fields[3]": "link",
                "fields[4]": "highlight",
                "fields[5]": "published_date",
                "fields[6]": "content",
                "fields[7]": "website",
                "sort[1]": "published_date:desc",
            },
        }
    )
    return response
}

export const getLatestArticles = async () => {
    const response = await generalApi.get(
        API.ARTICLES,
        {
            params: {
                populate: "*",
                "fields[0]": "title",
                "fields[1]": "slug",
                "fields[2]": "highlight",
                "fields[3]": "published_date",
                "fields[4]": "content",
                "fields[5]": "category",
                "fields[6]": "tags",
                "fields[7]": "website",
                "fields[8]": "author",
                "sort[1]": "published_date:desc",
                "pagination[limit]": 3,
            },
        }
    )
    return response
}

export const getAllArticles = async () => {
    const response = await generalApi.get(
        API.ARTICLES,
        {
            params: {
                populate: "*",
                "fields[0]": "title",
                "fields[1]": "slug",
                "fields[2]": "highlight",
                "fields[3]": "published_date",
                "fields[4]": "content",
                "fields[5]": "category",
                "fields[6]": "tags",
                "fields[7]": "website",
                "fields[8]": "author",
                "sort[1]": "published_date:desc",
            },
        }
    )
    return response
}